import styled from "@emotion/styled";
import {
  CLIENT_ICON_BACKGROUND_GRADIENT,
  ICON_BLUE_CONTAINER_BACKGROUND_COLOR_GRADIENT,
  ICON_HEADER_BACKGROUND_COLOR_GRADIENT,
  ICON_LIGHT_PINK_CONTAINER_BACKGROUND_COLOR_GRADIENT,
  MOBILE_SCREEN,
} from "../../theme";
import AttorneyLeaderboardCard from "./AttorneyLeaderboardCard";
import { PARTNER_NAME_CAPITALIZED } from "../../../utils/branding";
import User from "../../icons/User";
import Chats from "../../icons/Chats";
import Scales from "../../icons/Scales";
import ThumbsUp from "../../icons/ThumbsUp";

const AttorneyLeaderboardContainer = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 16px;
  ${MOBILE_SCREEN} {
    flex-direction: column;
  }
`;
const IconContainer = styled.div<{ color: string }>`
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  background: ${({ color }) => color};
  border-radius: 8px;
`;

interface AttorneyLeaderboardProps {
  clientsCount: number;
  qaCount: number;
  representationCount: number;
  reviewsRating: number;
}

const AttorneyLeaderboard = ({
  clientsCount,
  qaCount,
  representationCount,
  reviewsRating,
}: AttorneyLeaderboardProps) => {
  return (
    <AttorneyLeaderboardContainer>
      <AttorneyLeaderboardCard
        icon={
          <IconContainer color={CLIENT_ICON_BACKGROUND_GRADIENT}>
            <User />
          </IconContainer>
        }
        title="Total Clients"
        value={clientsCount.toString()}
      />
      <AttorneyLeaderboardCard
        icon={
          <IconContainer color={ICON_HEADER_BACKGROUND_COLOR_GRADIENT}>
            <Chats />
          </IconContainer>
        }
        title="Q&A Session"
        value={qaCount.toString()}
      />
      <AttorneyLeaderboardCard
        icon={
          <IconContainer
            color={ICON_LIGHT_PINK_CONTAINER_BACKGROUND_COLOR_GRADIENT}
          >
            <Scales />
          </IconContainer>
        }
        title="Representation"
        value={representationCount.toString()}
      />
      <AttorneyLeaderboardCard
        icon={
          <IconContainer color={ICON_BLUE_CONTAINER_BACKGROUND_COLOR_GRADIENT}>
            <ThumbsUp />
          </IconContainer>
        }
        title={`${PARTNER_NAME_CAPITALIZED} Rating`}
        value={reviewsRating === 0 ? "-" : reviewsRating.toString()}
      />
    </AttorneyLeaderboardContainer>
  );
};

export default AttorneyLeaderboard;
